import { ProTable } from '@bedrock/eed-react';
import BasePriceSelect from '#features/MPCDemand/BasePriceSelect';
import { cloneDeep } from 'lodash';

// 增加 ProTable 渲染与编辑渲染注册：基准价选择
ProTable.addEditRender(
    'mpc_base_price_config',
    ({ props, setRow, toggleEditableRowKey, getRowKey }, editable) => ({
      component: BasePriceSelect,
      props: {
        ...props,
        view: !editable,
        onChange(e, row, column, rowIndex, ...args) {
          // 深拷贝，触发表格行更新
          const changedRow = cloneDeep(row);
          setRow({
            ...changedRow,
            base_price_config: e.target.value,
          });
          props?.onChange?.(e, changedRow, column, rowIndex, ...args);
        },
      },
    })
  );